import React, {useEffect, useState} from 'react'
import {Outlet} from 'react-router-dom'
import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import {HeaderWrapper} from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {useLocation} from 'react-router-dom'
import {MenuComponent} from '../assets/ts/components'
import {Toolbar} from './components/toolbar/Toolbar'
import MobileAppModal from '../partials/modals/MobileAppModal'

const MOBILE_APP_PROMO_KEY = 'mobile_app_promo_shown'

const MasterLayout = () => {
  const location = useLocation()
  const [showMobileAppModal, setShowMobileAppModal] = useState(false)

  useEffect(() => {
    if (!sessionStorage.getItem(MOBILE_APP_PROMO_KEY)) {
      setShowMobileAppModal(true)
      sessionStorage.setItem(MOBILE_APP_PROMO_KEY, '1')
    }
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 0)
  }, [location.key])

  // Get direction
  const dir = localStorage.getItem('dir')

  return (
    <PageDataProvider>
      <div dir={dir === 'rtl' ? 'rtl' : 'ltr'} className={`page d-flex flex-row flex-column-fluid`}>
        <AsideDefault />
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper'>
          <HeaderWrapper />
          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            <Toolbar />
            <div className='post d-flex flex-column-fluid' id='kt_post'>
              <Content>
                <Outlet />
              </Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>
      <ScrollTop />
      <MobileAppModal showModal={showMobileAppModal} setShowModal={setShowMobileAppModal} />
    </PageDataProvider>
  )
}

export {MasterLayout}
